// Aviso fijo, visible para TODOS los usuarios de la compañía, cuando el plan
// venció (la prueba gratis de lanzamiento, o un plan pagado -Básico/Pro- sin
// renovar: ya no existe un "gratis para siempre" al que caer) y la cuenta
// queda en solo lectura (el backend rechaza cualquier cambio, ver
// authMiddleware). Sin este aviso, cada botón que intente guardar algo
// fallaría sin explicación.

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPlanStatus } from '../services/apiService';
import { FaLock } from 'react-icons/fa';

export default function ReadOnlyBanner() {
  const [estado, setEstado] = useState(null);

  useEffect(() => {
    let cancelado = false;
    getPlanStatus()
      .then((data) => {
        if (!cancelado) setEstado(data);
      })
      .catch(() => {
        // Si no se puede consultar, no se muestra nada: el aviso nunca debe romper la pantalla.
      });
    return () => {
      cancelado = true;
    };
  }, []);

  if (estado?.plan !== 'VENCIDO') return null;

  // storedPlan conserva el plan real aunque ya haya vencido: distingue si fue
  // la prueba gratis o un plan pagado, para no decirle "tu prueba" a alguien
  // que sí estaba pagando.
  const titulo = estado.storedPlan === 'LANZAMIENTO'
    ? 'Tu prueba gratis terminó: tu cuenta está en modo solo lectura'
    : 'Tu plan venció: tu cuenta está en modo solo lectura';

  return (
    <div className="mb-6 rounded-2xl bg-red-50 border border-red-100 p-4 md:p-5 flex flex-col sm:flex-row sm:items-center gap-3">
      <div className="w-10 h-10 rounded-xl bg-red-500 text-white flex items-center justify-center flex-shrink-0">
        <FaLock />
      </div>
      <div className="flex-1">
        <p className="font-black text-red-700">{titulo}</p>
        <p className="text-sm text-gray-600">
          Puedes ver toda tu información, pero no modificarla. Activa tu plan para volver a vender y editar tu inventario.
        </p>
      </div>
      <Link
        to="/planes"
        className="flex-shrink-0 text-center px-5 py-2.5 rounded-xl text-sm font-black text-white bg-red-500 hover:bg-red-600 transition-all active:scale-95"
      >
        Activar mi plan
      </Link>
    </div>
  );
}
